/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchClientsDictionaryResponse } from './search-clients-dictionary-response';


export interface SearchClientsDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchClientsDictionaryResponse> | null;
}

